import { render } from "./Transacoes.vue?vue&type=template&id=e57b5f3a&ts=true"
import script from "./Transacoes.vue?vue&type=script&lang=ts"
export * from "./Transacoes.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__